// React
import { useEffect, useState } from 'react';
// Redux
import { Dispatch } from 'redux';
import { useDispatch } from 'react-redux';
import { loginUser } from './../../actions/user';
import useFetch from './../../hooks/useFetch';
// Modules
import { Form } from 'react-bootstrap';
// Components
import { LogoAnim } from './LogoAnim';
import { VideoAnim } from './VideoAnim';
// Style
import './login.css';

declare global {
	interface Window {
		google: any;
	}
}

// URL list
export const API_URL = process.env.REACT_APP_API_URL;

export const Login = () => {
	const [data, setData] = useState<any>({});
	const [appleAuth, setAppleAuth] = useState<any>({});

	const dispatch: Dispatch<any> = useDispatch();

	const { handleGoogle, loading, error } = useFetch(API_URL + '/auth/googlelogin');

	useEffect(() => {
		if (window.google) {
			window.google.accounts.id.initialize({
				client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
				callback: handleGoogle,
			});

			window.google.accounts.id.renderButton(document.getElementById('loginDiv'), {
				// type: "standard",
				theme: 'filled_black',
				// size: "small",
				text: 'signin_with',
				shape: 'pill',
			});

			// google.accounts.id.prompt()
		}
	}, [handleGoogle]);

	const updateData = (e: any) => {
		setData({
			...data,
			[e.target.name]: e.target.value,
		});
	};

	const onFormSubmit = (e: any) => {
		e.preventDefault();

		if (data.hasOwnProperty('email') && data.hasOwnProperty('password')) {
			dispatch(loginUser(data.email as string, data.password as string));
		}
	};

	return (
		// <Container className={"main"}>
		<div className='login'>
			<div className='login-left'>
				<video
					className='login-video'
					autoPlay={true}
					muted={true}
					playsInline={true}
					loop={true}
					data-wf-ignore='true'
				>
					<source
						src='https://assets-global.website-files.com/60b8cabe0de4ed56211a6825/60b8cabe0de4edb4701a685d_PLAN_SITE_LOOP_01-poster-00001.jpg'
						data-wf-ignore='true'
					/>
					<source
						src='https://assets-global.website-files.com/60b8cabe0de4ed56211a6825/60b8cabe0de4edb4701a685d_PLAN_SITE_LOOP_01-transcode.mp4'
						data-wf-ignore='true'
					/>
					<source
						src='https://assets-global.website-files.com/60b8cabe0de4ed56211a6825/60b8cabe0de4edb4701a685d_PLAN_SITE_LOOP_01-transcode.webm'
						data-wf-ignore='true'
					/>
				</video>
				<VideoAnim />
			</div>
			<div className='login-right'>
				<div className='login-loginContainer'>
					<Form name='loginForm' className='login-loginContent' onSubmit={onFormSubmit}>
						<LogoAnim />

						<div className='login-header'>Connexion</div>
						<div className='input-container'>
							<input name='email' type='text' required={true} onChange={updateData} />
							<label>Email</label>
						</div>

						<div className='input-container' id='formBasicPassword'>
							<input name='password' type='password' required={true} onChange={updateData} />
							<label>Mot de passe</label>
						</div>

						<Form.Group className='checkout' controlId='formBasicCheckbox'>
							<Form.Check type='checkbox' label='Rester connecté' />
						</Form.Group>

						<a className='button-8 w-inline-block center pointer' onClick={(e) => onFormSubmit(e)}>
							<div className='text-small'>
								<strong className='bold-text'>Se connecter</strong>
							</div>
						</a>

						<div className='login-separator'></div>
						<div className='login-text'>Autre méthode</div>
						
						<div className='login-googleContainer'>
							{error && <p style={{ color: 'red' }}>{error}</p>}
							{loading ? <div>Loading....</div> : <div id='loginDiv'></div>}
						</div>
					</Form>
				</div>
			</div>
		</div>
		// </Container>
	);
};
